import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const matSnackBarConfig: MatSnackBarConfig = {
  panelClass: ['fibii-tooltip'],
  verticalPosition: 'top',
  horizontalPosition: 'right',
  duration: 6000,
};
